import { render, staticRenderFns } from "./MoveIcon.vue?vue&type=template&id=257e3a69&"
import script from "./MoveIcon.vue?vue&type=script&lang=js&"
export * from "./MoveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports